import { MarketplaceCard } from 'src/components/MarketplaceCard';
import { MarketplaceCarousel } from 'src/components/MarketplaceCarousel';
import { useWindowWidth } from 'src/hooks/useWindowWidth';
import type { ParsedProductPreview } from 'src/types/marketplace';
import { Button } from 'src/uikit/Button';
import { ChevronRightIcon } from 'src/uikit/icons/ChevronRightIcon';
import { Tag } from 'src/uikit/Tag';

import s from './MarketplaceShowcaseBlock.module.scss';

const MocksRu = {
  showAll: 'Показать все',
};

export type Props = {
  title: string;
  description?: string;
  onCategoryChange?: () => void;
  counter?: number;
  isPopular?: boolean;
  cards: ParsedProductPreview[];
};

export function MarketplaceShowcaseBlock({
  title,
  description,
  onCategoryChange,
  counter,
  isPopular,
  cards,
}: Props) {
  const {
    windowWidth,
    breakpoints: { SM },
  } = useWindowWidth();

  return (
    <div className={s.root}>
      <div className={s.heading}>
        <div className={s.texts}>
          <h2 className={s.title}>
            {title}

            {counter && (
              <Tag
                variant={Tag.variants.Primary}
                appearance={Tag.appearances['gray-80']}
              >
                {counter}
              </Tag>
            )}
          </h2>

          {description && <p className={s.description}>{description}</p>}
        </div>

        {windowWidth && windowWidth >= SM && onCategoryChange ? (
          <Button
            className={s.button}
            variant={Button.variants.Tertiary}
            onClick={onCategoryChange}
            analyticsOptions={{
              action: 'click',
              clickZone: 'body',
              clickElement: 'button',
              clickContent: MocksRu.showAll + ' ' + title,
              uniqueId: 'marketplace-body-category-change',
              transitionType: 'inside-link',
            }}
          >
            <span>{MocksRu.showAll}</span>
            <ChevronRightIcon />
          </Button>
        ) : null}
      </div>

      {isPopular ? (
        <MarketplaceCarousel slides={cards} />
      ) : (
        <div className={s.body}>
          {cards.map((card) => (
            <MarketplaceCard key={card.slug} {...card} />
          ))}
        </div>
      )}

      {windowWidth && windowWidth < SM && onCategoryChange ? (
        <Button
          className={s.button}
          variant={Button.variants.Tertiary}
          onClick={onCategoryChange}
          analyticsOptions={{
            action: 'click',
            clickZone: 'body',
            clickElement: 'button',
            clickContent: MocksRu.showAll + ' ' + title,
            uniqueId: 'marketplace-body-category-change',
            transitionType: 'inside-link',
          }}
        >
          <span>{MocksRu.showAll}</span>
          <ChevronRightIcon />
        </Button>
      ) : null}
    </div>
  );
}
